const DEFAULT_API_BASE_URL = "/api";

export const normalizeApiBaseUrl = (rawBaseUrl = process.env.REACT_APP_API_URL) => {
  const value = (rawBaseUrl || DEFAULT_API_BASE_URL).trim().replace(/\/+$/, "");
  if (!value) return DEFAULT_API_BASE_URL;

  // Cookie scope treats localhost and 127.0.0.1 as different hosts.
  // Keep local API calls on localhost so login, profile restore, and data fetches
  // all share the same cookie jar during development.
  return value.replace(/^http:\/\/127\.0\.0\.1:5001\b/, "http://localhost:5001");
};

export const API_BASE_URL = normalizeApiBaseUrl();
